/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PaginatedAssetLogsResponseDto,
  StreamGoldenRecordsRequestDto,
  StreamGoldenRecordsResponseDto,
  UpdateAssetLogRequestDto,
} from '../models/index';
import {
    PaginatedAssetLogsResponseDtoFromJSON,
    PaginatedAssetLogsResponseDtoToJSON,
    StreamGoldenRecordsRequestDtoFromJSON,
    StreamGoldenRecordsRequestDtoToJSON,
    StreamGoldenRecordsResponseDtoFromJSON,
    StreamGoldenRecordsResponseDtoToJSON,
    UpdateAssetLogRequestDtoFromJSON,
    UpdateAssetLogRequestDtoToJSON,
} from '../models/index';

export interface GoldenRecordStreamControllerGetLogsForAssetRequest {
    assetId: string;
    organizationId: string;
    isTreated?: boolean;
    to?: string;
    from?: string;
    cursor?: string;
    limit?: number;
}

export interface GoldenRecordStreamControllerStreamForAssetRequest {
    assetId: string;
    organizationId: string;
    streamGoldenRecordsRequestDto: StreamGoldenRecordsRequestDto;
}

export interface GoldenRecordStreamControllerUpdateLogForAssetRequest {
    logId: string;
    assetId: string;
    organizationId: string;
    updateAssetLogRequestDto: UpdateAssetLogRequestDto;
}

/**
 * 
 */
export class NormalizeLogsAtRestApi extends runtime.BaseAPI {

    /**
     * Cursor pagination (limit + opaque cursor). Breaking change vs offset page/total: use cursor, hasNextPage, nextCursor. Unknown query params (e.g. page) are rejected.
     * Retrieve paginated golden-record logs for an asset
     */
    async goldenRecordStreamControllerGetLogsForAssetRaw(requestParameters: GoldenRecordStreamControllerGetLogsForAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAssetLogsResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling goldenRecordStreamControllerGetLogsForAsset().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling goldenRecordStreamControllerGetLogsForAsset().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isTreated'] != null) {
            queryParameters['isTreated'] = requestParameters['isTreated'];
        }

        if (requestParameters['to'] != null) {
            queryParameters['to'] = requestParameters['to'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/logs`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAssetLogsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Cursor pagination (limit + opaque cursor). Breaking change vs offset page/total: use cursor, hasNextPage, nextCursor. Unknown query params (e.g. page) are rejected.
     * Retrieve paginated golden-record logs for an asset
     */
    async goldenRecordStreamControllerGetLogsForAsset(requestParameters: GoldenRecordStreamControllerGetLogsForAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAssetLogsResponseDto> {
        const response = await this.goldenRecordStreamControllerGetLogsForAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queue a log replay for one asset and stream batches over NATS
     */
    async goldenRecordStreamControllerStreamForAssetRaw(requestParameters: GoldenRecordStreamControllerStreamForAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamGoldenRecordsResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling goldenRecordStreamControllerStreamForAsset().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling goldenRecordStreamControllerStreamForAsset().'
            );
        }

        if (requestParameters['streamGoldenRecordsRequestDto'] == null) {
            throw new runtime.RequiredError(
                'streamGoldenRecordsRequestDto',
                'Required parameter "streamGoldenRecordsRequestDto" was null or undefined when calling goldenRecordStreamControllerStreamForAsset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/normalize-logs`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreamGoldenRecordsRequestDtoToJSON(requestParameters['streamGoldenRecordsRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamGoldenRecordsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Queue a log replay for one asset and stream batches over NATS
     */
    async goldenRecordStreamControllerStreamForAsset(requestParameters: GoldenRecordStreamControllerStreamForAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamGoldenRecordsResponseDto> {
        const response = await this.goldenRecordStreamControllerStreamForAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an untreated golden-record log for an asset
     */
    async goldenRecordStreamControllerUpdateLogForAssetRaw(requestParameters: GoldenRecordStreamControllerUpdateLogForAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['logId'] == null) {
            throw new runtime.RequiredError(
                'logId',
                'Required parameter "logId" was null or undefined when calling goldenRecordStreamControllerUpdateLogForAsset().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling goldenRecordStreamControllerUpdateLogForAsset().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling goldenRecordStreamControllerUpdateLogForAsset().'
            );
        }

        if (requestParameters['updateAssetLogRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateAssetLogRequestDto',
                'Required parameter "updateAssetLogRequestDto" was null or undefined when calling goldenRecordStreamControllerUpdateLogForAsset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/logs/{logId}`;
        urlPath = urlPath.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters['logId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAssetLogRequestDtoToJSON(requestParameters['updateAssetLogRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update an untreated golden-record log for an asset
     */
    async goldenRecordStreamControllerUpdateLogForAsset(requestParameters: GoldenRecordStreamControllerUpdateLogForAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.goldenRecordStreamControllerUpdateLogForAssetRaw(requestParameters, initOverrides);
    }

}
